import React, { useEffect } from 'react'
import { SplitAffectation } from '../../../models/Portfolio';
import { useAppDispatch, useAppSelector } from '../../../store/reducers/store';
import { useTheme } from '@emotion/react';
import { Box, CircularProgress, ITheme, Link, Typography } from '@mui/material';
import { loadSplits } from '../../../store/actions/createPortfolio';
import { Split } from '../../../models/Common';
import { LeoImagesSplitsPath } from '../../../resources/api-constants';
import ProportionSelector from './ProportionSelector';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

export interface ISplitSelectorProps {
    value: SplitAffectation[];
    onSplitsChanged: (sectors: SplitAffectation[]) => void;
}

const SplitSelector:React.FC<ISplitSelectorProps> = ({ onSplitsChanged, value }) => {
    const theme = useTheme() as ITheme;
    const dispatch = useAppDispatch();
    const splits = useAppSelector(state => state.createPortfolio.splits);
    const { t } = useTranslation();

    useEffect(() => {
        if (splits === undefined){
            dispatch(loadSplits());
        }
    }, [splits, dispatch]);

    if (splits === undefined){
        return <CircularProgress />
    }

    const onSplitSelected = (id: number): void => {
        const selection = [...value];
        const existingIndex = selection.findIndex(i => i.id === id);
        if (existingIndex !== -1){
            selection.splice(existingIndex, 1);
        } else {
            const split = splits.find(s => s.id === id);
            if (split){
                selection.push({ ...split, proportion : 0})
            }
        }
        onSplitsChanged(selection);
    }
    
    const onProportionChanged = (id: number, proportion: number): void => {
        const selection = [...value];
        let total = selection.reduce((a, b) => a + b.proportion, 0);
        const existingIndex = selection.findIndex(i => i.id === id);
        if (existingIndex !== -1) {
            let correctedValue = proportion;
            total -= selection[existingIndex].proportion;
            if (total + correctedValue > 1){
                correctedValue = 1 - total;
            }
            selection[existingIndex] = { ...selection[existingIndex], proportion: correctedValue };
        }
        onSplitsChanged(selection);
    }

    const renderSplit = (split: Split, affectation: SplitAffectation | undefined, onClick: (id: number) => void): React.ReactNode => {
        const selected = affectation !== undefined
        return <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} key={`split-${split.id}`}
                bgcolor={selected ? theme.palette.primary.dark: theme.palette.background.paper} color={selected ? theme.palette.common.white: theme.palette.text.primary} borderRadius={"4px"}
                padding={"8px 12px"} gap={"8px"} onClick={()=> onClick(split.id)} sx={{ cursor: "pointer", userSelect: "none"}}>
            {split.icon && <img src={`${LeoImagesSplitsPath}/${selected ? "selected-" : ""}${split.icon}`} className={selected ? "svg-color-white" : ""} style={{ width: "24px", height: "24px" }}
                onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => { e.currentTarget.style.display='none';}}/>}
            <Typography fontSize={"13px"} lineHeight={"20px"} fontWeight={"500"} color={selected ? theme.palette.common.white: theme.palette.text.primary}>{split.name}</Typography>
            {/* {selected && <ProportionSelector value={affectation.proportion} onProportionChanged={(val: number) => onProportionChanged(split.id, val)} />} */}
            {selected && <Link sx={{ color: theme.palette.primary.light}}><CloseIcon fontSize='small' sx={{ color: theme.palette.primary.light}} /></Link>}
        </Box>
    }
  return (
    <Box display={"flex"} flexDirection={"column"} gap={"26px"}>
        <Typography fontSize={"16px"} fontWeight={"500"} lineHeight={"19.5px"}>{t('CreatePortfolioSelectGeographyLabel')}</Typography>
        <Box display={"flex"} flexWrap={"wrap"} gap={"12px"}>{splits.map(s => renderSplit(s, value.find(c => c.id === s.id), onSplitSelected))}</Box>
    </Box>
  )
}

export default SplitSelector